module.exports = __webpack_public_path__ + "static/img/beian.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/beian.png
// module id = mENG
// module chunks = 1 2 3 4 5 6